// eslint-disable-next-line import/no-extraneous-dependencies
import * as React from "react";
export { React };
